import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import cep from 'cep-promise';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.css'],
  standalone: false,
})
export class AddressFormComponent {
  @Input() formGroup!: FormGroup;
  constructor(private spinner: NgxSpinnerService) {}

  async handlePostcode() {
    const postcode = this.formGroup.get('postalCode')?.value;

    if (postcode && this.formGroup.get('postalCode')?.valid) {
      try {
        void this.spinner.show();
        const fetched = await cep(postcode);

        this.formGroup.patchValue({
          street: fetched.street.toUpperCase(),
          neighborhood: fetched.neighborhood.toUpperCase(),
          state: fetched.state.toUpperCase(),
          city: fetched.city.toUpperCase(),
        });
      } catch (e) {
        console.error('Error fetching address:', e);
      } finally {
        void this.spinner.hide();
      }
    }
  }
}
